export enum LocalStorageKey {
  Template = 'GA_TEMPLATE',
  UpdatingPlan = 'GA_UPDATING_PLAN',
  VerificationEmail = 'GA_VERIFICATION_EMAIL',
  SignupAnalyticsData = 'GA_SIGNUP_ANALYTICS_DATA',
}
